module.exports = __webpack_public_path__ + "static/media/grupo sura.9103f0e6.svg";